module.exports = __webpack_public_path__ + "img/Gischt.307d1205.svg";